<div style="width: 800px; height: 500px;" data-cy="ar-ledger-item-select">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-ledger-item-select-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-ledger-item-select-header">
      <div class="section-header-title" data-cy="ar-ledger-item-select-title">
        Select ledger Item
      </div>
      <div style="flex: 1;" data-cy="ar-ledger-item-select-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;" data-cy="ar-ledger-item-select-content">
      <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="ar-ledger-item-select-spinner"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" style="flex: 1; overflow-y: hidden;" data-cy="ar-ledger-item-select-loaded-content">

        <div style="flex: 1; overflow-y: auto; height: 380px; margin-top: 2px;" data-cy="ar-ledger-item-select-table-container">
          <tdo-table [cypressControlIdentifier]="'ledger-item'"
            *ngIf="!isShowCredits"
            [dataSource]="ledgerItems"
                     [isMultiSelection]="false"
                     [isSearchable]="false"
                     [isUsePaginator]="false"
                     (rowSelected)="onRowSelected($event)"
                     data-cy="ar-ledger-item-select-debits-table">
            <tdo-table-column displayName="Post Date" propertyName="PostDate" isSortable="true" [rowTemplate]="postDate" data-cy="ar-ledger-item-select-debits-col-date">
              <ng-template #postDate let-row>
                <div matTooltip="{{ convertUTCDatetoTimezone(row.PostDate, this.TZID) | date:'medium' }}" data-cy="ar-ledger-item-select-debits-date">
                  {{ convertUTCDatetoTimezone(row.PostDate, this.TZID) | date }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Code" targetObjectName="dataARTransactionItemList" propertyName="Code" isSortable="true" [rowTemplate]="code" data-cy="ar-ledger-item-select-debits-col-code">
              <ng-template #code let-row>
                                  <div *ngIf="row.model.dataARTransactionItemList && row.model.dataARTransactionItemList.Code" data-cy="ar-ledger-item-select-debits-code">
                  {{ row.model.dataARTransactionItemList.Code }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Origin" propertyName="enumARLedgerItemOriginTypeID" isSortable="true" [rowTemplate]="origin" data-cy="ar-ledger-item-select-debits-col-origin">
              <ng-template #origin let-row>
                <div *ngIf="row.model.enumARLedgerItemOriginTypeID" style="padding-right:10px" data-cy="ar-ledger-item-select-debits-origin">
                  <div *ngIf="row.model.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypePatient && row.model.enumARLedgerItemTypeID !== this.enumLedgerItemTypeCreditPayment" data-cy="ar-ledger-item-select-debits-origin-patient">
                    Pat.Est.
                  </div>
                  <div *ngIf="row.model.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypeInsurance" data-cy="ar-ledger-item-select-debits-origin-insurance">
                    Ins.Est.
                  </div>
                  <div *ngIf="row.model.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypeTransaction" data-cy="ar-ledger-item-select-debits-origin-transaction">
                    Trans.
                  </div>
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Contracted Amount" propertyName="Amount1" [rowTemplate]="debit" data-cy="ar-ledger-item-select-debits-col-amount">
              <ng-template #debit let-row>
                <div *ngIf="row.model.Amount" data-cy="ar-ledger-item-select-debits-amount">
                  {{ row.model.Amount | currency }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Patient Estimate Due" propertyName="AmountDuePatient" [rowTemplate]="amountduepatient" data-cy="ar-ledger-item-select-debits-col-patient-due">
              <ng-template #amountduepatient let-row>
                <div *ngIf="row.model.AmountDuePatient !== null && row.model.AmountDuePatient !== undefined" data-cy="ar-ledger-item-select-debits-patient-due">
                  {{ row.model.AmountDuePatient | currency }}
                </div>
              </ng-template>
            </tdo-table-column>

          </tdo-table>
          <tdo-table
            [cypressControlIdentifier]="'ledger-item'"
            *ngIf="isShowCredits"
            [dataSource]="ledgerItems"
                     [isMultiSelection]="false"
                     [isSearchable]="false"
                     [isUsePaginator]="false"
                     (rowSelected)="onRowSelected($event)"
                     data-cy="ar-ledger-item-select-credits-table">
            <tdo-table-column displayName="Post Date" propertyName="PostDate" isSortable="true" [rowTemplate]="postDate" data-cy="ar-ledger-item-select-credits-col-date">
              <ng-template #postDate let-row>
                <div matTooltip="{{ convertUTCDatetoTimezone(row.PostDate, this.TZID) | date:'medium' }}" data-cy="ar-ledger-item-select-credits-date">
                  {{ convertUTCDatetoTimezone(row.PostDate, this.TZID) | date }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Reference" propertyName="Reference" isSortable="true" [rowTemplate]="ref" data-cy="ar-ledger-item-select-credits-col-reference">
              <ng-template #ref let-row>
                <div *ngIf="row.model.Reference" style="max-width: 300px; white-space: pre-line" data-cy="ar-ledger-item-select-credits-reference">
                  {{ row.model.Reference }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Description" propertyName="Description" isSortable="true" [rowTemplate]="description" data-cy="ar-ledger-item-select-credits-col-description">
              <ng-template #description let-row>
                <div *ngIf="row.model.Description && row.model.Description" style="max-width: 300px; white-space: pre-line" data-cy="ar-ledger-item-select-credits-description">
                  {{ row.model.Description }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Amount" propertyName="Amount1" [rowTemplate]="amt" data-cy="ar-ledger-item-select-credits-col-amount">
              <ng-template #amt let-row>
                <div *ngIf="row.model.Amount" data-cy="ar-ledger-item-select-credits-amount">
                  {{ row.model.Amount | currency }}
                </div>
              </ng-template>
            </tdo-table-column>

          </tdo-table>
        </div>

      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="ar-ledger-item-select-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="ar-ledger-item-select-footer-spacer"></div>
      <button data-cy="cancel-btn" (click)="close(false)" class="tdo-button tdo-close" style="margin-right: 10px;">Cancel</button>
      <button data-cy="save-btn" (click)="save()" class="tdo-button tdo-save" style="margin-right: 6px;">Ok</button>
    </div>
  </div>
</div>
